import { createSlice } from '@reduxjs/toolkit';
import { fetchDailyTrivia, submitTriviaAnswer } from '../../store/thunks/triviaThunks';

const initialState = {
    dailyTrivia: null,
    loading: false,
    error: null,
    submissionResult: null,
    lastSubmission: null
};

const triviaSlice = createSlice({
    name: 'trivia',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDailyTrivia.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDailyTrivia.fulfilled, (state, action) => {
                state.loading = false;
                state.dailyTrivia = action.payload;
                state.error = null;
            })
            .addCase(fetchDailyTrivia.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(submitTriviaAnswer.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.submissionResult = null;
            })
            .addCase(submitTriviaAnswer.fulfilled, (state, action) => {
                state.loading = false;
                state.submissionResult = action.payload;
                state.lastSubmission = action.payload;
                state.error = null;
            })
            .addCase(submitTriviaAnswer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.submissionResult = null;
            });
    }
});

export default triviaSlice.reducer;